module.exports = __webpack_public_path__ + "static/img/Patient_List_in_Hospitals.cf823c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Patient_List_in_Hospitals.jpg
// module id = PgIw
// module chunks = 0